import { Routes } from '@angular/router';

import { errorRoutes } from '../../not-found-error/not-found-error.page';

export const jobsRoutes: Routes = [
  {
    path: '',

    title: 'Jobs & tests overview  - Alpha Scientific',
    loadComponent: () =>
      import('./jobs-and-tests.page').then((m) => m.JobsAndTestsOverviewPage),
    children: [
      // Jobs
      {
        path: '',
        loadComponent: () =>
          import('./pages/jobs/jobs.page').then((m) => m.JobsPage),
      },
      {
        path: 'job/:jobId',
        loadComponent: () => import('./pages/jobs/job/job.page').then((m) => m.JobPage),
        title: ({ params }) =>
          `${params['jobId'] || 'Loading..'} - Job - Alpha Scientific`,
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/jobs/job/job-details/job-details.component').then(m => m.JobDetailsComponent),
          },
          {
            path: 'samples',
            loadComponent: () =>
              import('./pages/jobs/job/job-samples/job-samples.component').then(m => m.JobSamplesComponent),
          },
          {
            path: 'samples/:sampleId',
            loadComponent: () =>
              import('./pages/jobs/job/job-samples/sample/sample.page').then((m) => m.SamplePage),
            title: 'Sample - Alpha Scientific',
          },
          {
            path: 'documents',
            loadComponent: () =>
              import('./pages/jobs/job/job-documents/job-documents.component').then(m => m.JobDocumentsComponent),
          },
        ],
      },

      // Templates
      {
        path: 'templates',
        loadComponent: () =>
          import('./pages/templates/templates.page').then((m) => m.TemplatesPage),
      },
      {
        path: 'templates/:templateId',
        loadComponent: () => import('./pages/templates/template/template.page').then((m) => m.TemplatePage),
        title: ({ params }) =>
          `${params['templateId'] || 'Loading..'} - Job - Alpha Scientific`,
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/templates/template/template-details/template-details.component').then(m => m.TemplateDetailsComponent),
          },
          {
            path: 'samples',
            loadComponent: () =>
              import('./pages/templates/template/template-samples/template-samples.component').then(m => m.TemplateSamplesComponent),
          },
          {
            path: 'samples/:sampleId',
            loadComponent: () =>
              import('./pages/templates/template/template-samples/sample/sample.page').then((m) => m.TemplateSamplePage),
            title: 'Sample - Alpha Scientific',
          },
        ],
      },
    ]
  },
  ...errorRoutes,
];
